import {
    Icon,
    IconProps,
    IconSquare,
    IconSquareLetterA,
    IconSquareLetterB,
    IconSquareLetterC,
    IconSquareLetterD,
    IconSquareLetterE,
    IconSquareLetterF,
    IconSquareLetterG,
    IconSquareLetterH,
    IconSquareLetterI,
    IconSquareLetterJ,
    IconSquareLetterK,
    IconSquareLetterL,
    IconSquareLetterM,
    IconSquareLetterN,
    IconSquareLetterO,
    IconSquareLetterP,
    IconSquareLetterQ,
    IconSquareLetterR,
    IconSquareLetterS,
    IconSquareLetterT,
    IconSquareLetterU,
    IconSquareLetterV,
    IconSquareLetterW,
    IconSquareLetterX,
    IconSquareLetterY,
    IconSquareLetterZ,
} from '@tabler/icons-react'

// Tabler ships no Norwegian letters, so we author Å/Æ/Ø glyphs in the outline style of the built-in square-letter icons.
const SquareLetterGlyph = ({ size = 24, stroke = 2, color = 'currentColor', children, ...props }: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
    >
        <path d="M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14" />
        {children}
    </svg>
)

const IconSquareLetterAa: Icon = props => (
    <SquareLetterGlyph {...props}>
        <path d="M10 17v-5a2 2 0 1 1 4 0v5" />
        <path d="M10 14h4" />
        <path d="M12 6.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
    </SquareLetterGlyph>
)

const IconSquareLetterAe: Icon = props => (
    <SquareLetterGlyph {...props}>
        <path d="M8 16l3 -8h5" />
        <path d="M11 8v8h5" />
        <path d="M11 12h4" />
        <path d="M9 13h2" />
    </SquareLetterGlyph>
)

const IconSquareLetterOe: Icon = props => (
    <SquareLetterGlyph {...props}>
        <path d="M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2" />
        <path d="M10 16l4 -8" />
    </SquareLetterGlyph>
)

const LETTER_ICONS: Record<string, Icon> = {
    A: IconSquareLetterA,
    B: IconSquareLetterB,
    C: IconSquareLetterC,
    D: IconSquareLetterD,
    E: IconSquareLetterE,
    F: IconSquareLetterF,
    G: IconSquareLetterG,
    H: IconSquareLetterH,
    I: IconSquareLetterI,
    J: IconSquareLetterJ,
    K: IconSquareLetterK,
    L: IconSquareLetterL,
    M: IconSquareLetterM,
    N: IconSquareLetterN,
    O: IconSquareLetterO,
    P: IconSquareLetterP,
    Q: IconSquareLetterQ,
    R: IconSquareLetterR,
    S: IconSquareLetterS,
    T: IconSquareLetterT,
    U: IconSquareLetterU,
    V: IconSquareLetterV,
    W: IconSquareLetterW,
    X: IconSquareLetterX,
    Y: IconSquareLetterY,
    Z: IconSquareLetterZ,
    Å: IconSquareLetterAa,
    Æ: IconSquareLetterAe,
    Ø: IconSquareLetterOe,
}

type SquareLetterIconProps = IconProps & { letter: string }

export const SquareLetterIcon = ({ letter, ...props }: SquareLetterIconProps) => {
    const LetterIcon = LETTER_ICONS[letter.toUpperCase()] ?? IconSquare
    return <LetterIcon {...props} />
}
